import { Plugin } from 'chart.js';
import { ChartDragging, drawCircle, drawDragDots, drawLine, overviewColors } from './ChartUtils';

export const drawLinePlugin: Plugin<'line'> = {
  id: 'drawLine',
  afterDraw: (chart: ChartDragging) => {
    const { ctx, dragPoint, isDragging, options } = chart;
    const pluginOptions = (options.plugins as any)?.drawLinePlugin;

    const dragX = pluginOptions?.xPoint || dragPoint?.x;

    const topY = chart.scales?.y?.top;
    if (!topY) {
      return;
    }
    const bottomY = chart.scales.y.bottom;
    const middleY = (bottomY - topY) / 2;

    drawLine(ctx, dragX, topY, bottomY, overviewColors.marker);
    drawDragDots(ctx, dragX, middleY, overviewColors.marker);
    drawCircle(ctx, dragX, bottomY, overviewColors.marker);

    ctx.canvas.style.cursor = isDragging ? 'cursor-col-resize' : 'default';
    ctx.restore();
  },
};
